import { MGPMap } from '@everyboard/lib';
import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { CoordSet } from '../../jscaip/CoordSet';
import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { Player } from '../../jscaip/Player';
export class CoerceoHeuristic extends PlayerMetricHeuristic {
    getPiecesMap(state) {
        const map = new MGPMap();
        const zeroPieces = [];
        const onePieces = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            const piece = state.getPieceAt(coord);
            if (piece === FourStatePiece.ZERO) {
                zeroPieces.push(coord);
            }
            else if (piece === FourStatePiece.ONE) {
                onePieces.push(coord);
            }
        }
        map.set(Player.ZERO, new CoordSet(zeroPieces));
        map.set(Player.ONE, new CoordSet(onePieces));
        return map;
    }
    getPiecesFreedomScore(state) {
        const piecesByFreedom = state.getPiecesByFreedom();
        return [
            this.getPlayerPiecesScore(piecesByFreedom.get(Player.ZERO).get()),
            this.getPlayerPiecesScore(piecesByFreedom.get(Player.ONE).get()),
        ];
    }
    getPlayerPiecesScore(piecesScores) {
        // Since having exactly one freedom left is less advantageous, as more dangerous
        const capturableScore = 1;
        const safeScore = 3;
        return (safeScore * piecesScores[0]) +
            (capturableScore * piecesScores[1]) +
            (safeScore * piecesScores[2]) +
            (safeScore * piecesScores[3]);
    }
}
